import React from 'react'
import { ImageBlock } from './styles'
import type { CmsImageBlockProps } from './types'

const CmsImageBlock: React.FC<CmsImageBlockProps> = ({ data }) =>
  data.src ? <ImageBlock src={data.src} alt={data.altText ?? ''} /> : null

export default CmsImageBlock
